<!-- 引导加群 -->
<template>
  <div class="box">
    <div class="textContainer">
      <div class="contentBox">
        <div class="title">{{ props.msg.conTitle }}</div>
        <div class="tip">{{ props.msg.description }}</div>
        <div class="listBox">
          <div
            v-for="(item, index) in parseCustomString(props.msg.benefitItemVOList)"
            :key="index"
            class="item"
          >
            <img
              src="https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/cdn/shield.png"
              alt=""
            />
            <span>{{ item.content }}</span>
            <span v-if="item.tag" class="itemTip">{{ item.tag }}</span>
          </div>
        </div>
        <div class="clickable">{{ props.msg.buttonText }}</div>
        <div
          class="openClick"
          v-if="props.source !== 'NEW_INDEX' && JSON.parse(props.msg.showDismiss || 'false')"
        >
          不再提醒
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  msg: {
    type: Object,
    default: () => ({})
  },
  source: {
    type: String,
    default: ''
  }
})

const parseCustomString = str => {
  if (typeof str !== 'string') {
    return str
  }
  // 将所有 key=value 转为 "key":"value"
  const jsonStr = str.replace(/(\w+)=([^,}\]]+)/g, '"$1":"$2"')
  return JSON.parse(jsonStr)
}
</script>

<style scoped lang="scss">
$color-title: #1b1b1b;
$color-desc: #666666;
$color-list: #1b1b1b;
$color-tip: #999999;
$color-link: #b3b3b3;
$color-primary: #1890ff;

.box {
  .textContainer {
    position: relative;
    padding: 14px;
    border-radius: 0 8px 8px 8px;
    background-color: #ffffff;
    overflow: hidden;

    &.noGradient {
      border-radius: 8px;
      padding: 10px 10px 12px;

      &::before {
        display: none;
      }

      .contentBox {
        .title {
          font-size: 16px;
          line-height: 25px;
        }
      }
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 50px;
      background: linear-gradient(180deg, #d3e2ff 0%, #ffffff 100%);
      border-radius: 0 8px 0 0;
      z-index: 0;
    }

    .contentBox {
      position: relative;
      z-index: 1;

      .title {
        font-weight: 600;
        font-size: 18px;
        line-height: 18px;
        color: $color-title;
      }

      .tip {
        margin: 4px 0 12px;
        font-weight: 400;
        font-size: 15px;
        line-height: 22px;
        letter-spacing: 0.04em;
        color: $color-desc;
      }

      .listBox {
        display: flex;
        flex-direction: column;
        gap: 8px;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
        color: $color-list;

        .item {
          display: flex;
          align-items: center;
          gap: 6px;

          img {
            flex-shrink: 0;
            width: 18px;
            height: 18px;
          }

          .itemTip {
            font-weight: 400;
            font-size: 14px;
            line-height: 14px;
            color: $color-tip;
          }
        }
      }
    }

    .clickable {
      box-sizing: border-box;
      width: 100%;
      height: 38px;
      margin-top: 16px;
      border-radius: 8px;
      //background: $color-primary;
      background: rgba(76, 110, 224, 0.3);
      font-weight: 500;
      font-size: 14px;
      line-height: 38px;
      color: #ffffff;
      text-align: center;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }
    }

    .openClick {
      width: 100%;
      margin-top: 12px;
      font-weight: 400;
      font-size: 13px;
      line-height: 13px;
      //color: $color-link;
      color: #b3b3b3;
      text-align: center;
      cursor: pointer;
    }
  }
}

.qr-modal {
  display: flex;
  justify-content: center;
  padding: 12px 0 4px;

  .qr-image {
    width: 240px;
    height: 240px;
  }

  .qr-empty {
    color: #999;
    font-size: 14px;
    padding: 40px 0;
  }
}
</style>
